import { ServiceSessionUserEvent } from '@modules/ServiceModule/workspace/types/ServiceEvents';
import { InboxContext } from '../types';
import { setExternalCallToTimedOut } from '../callHandlers/externalCalls';
import TasksModule from '@modules/TasksModule';
import { TaskState } from '@modules/TasksModule/types';

/**
 * The session reject event is fired whenever a session is rejected by the agent OR the user times out.
 *
 * `setExternalCallToTimedOut` will only set the state to TIMEDOUT if the task is in the OFFERED state.
 *
 * In the case of a timeout, the task will be in the OFFERED state and this handler will set the state to TIMEDOUT.
 *
 * In the case the agent rejects the call, `handleTaskReject` will set the task to REJECTED state. By the time this event fires,
 * the task should already be in the REJECTED state, `setExternalCallToTimedOut` will do nothing if the task in the REJECTED state.
 */
function handleSessionRejected(
  context: InboxContext,
  event: ServiceSessionUserEvent,
) {
  const task = TasksModule.getTask(event.sessionSid);
  if (!task) {
    context.logger.error('task not found', event.sessionSid);
    return;
  } else if (task.state === TaskState.Offered) {
    setExternalCallToTimedOut(context, event.sessionSid, event.userId);
  }
}

export default handleSessionRejected;
